import { PropType, computed, defineComponent } from 'vue'

import { CsInputField } from '@sunrise/components'

export default defineComponent({
    name: 'MsFilterMinMax',
    components: { CsInputField },
    props: {
        minLabel: {
            type: String,
            default: 'Von',
        },
        maxLabel: {
            type: String,
            default: 'Bis',
        },
        values: {
            type: Object as PropType<{ min: number; max: number }>,
            required: true,
        },
    },
    emits: ['update:minMaxValue'],
    setup(props, { emit }) {
        const currentValues = computed(() => ({
            min: props.values.min?.toString() || '',
            max: props.values.max?.toString() || '',
        }))

        const regexNumberOnly = '^\\d*\\.?\\d+$'

        function onInputTrigger() {
            let newMax = Number(currentValues.value.max)
            if (Number(currentValues.value.min) > Number(currentValues.value.max)) {
                newMax = updateMax()
            }
            emit('update:minMaxValue', {
                min: currentValues.value.min ? Number(currentValues.value.min) : undefined,
                max: currentValues.value.max ? newMax : undefined,
            })
        }

        function updateMax(): number {
            return Number(currentValues.value.min)
        }

        return { onInputTrigger, currentValues, regexNumberOnly }
    },
})
